import { $userEmailSettings, $userIdentity } from './states';
import { fetchUserEmailSettings, fetchUserIdentity } from './effects';

// Fetch user identity
$userIdentity.on(fetchUserIdentity.doneData, (_, data) => data);

// Fetch user email settings
$userEmailSettings.on(fetchUserEmailSettings.doneData, (_, data) => data);
